'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { trackGtmEvent } from 'libs/gtm';
import { RETURNING_MEMBER_COOKIE } from 'utils/cookies';
import { trackReturningMemberPageViewed } from './eventHandlerTracking';
import { ANALYTICS_EVENTS } from './types';
import { getCookieValue } from './utils';

export function ReturningMemberTracker() {
  const pathname = usePathname();

  // Keyed on pathname: the root layout stays mounted across client-side navigations, which are page views too.
  useEffect(() => {
    if (getCookieValue(RETURNING_MEMBER_COOKIE) !== 'true') return;

    trackGtmEvent(ANALYTICS_EVENTS.LP_SEG_DETECTED);
    trackReturningMemberPageViewed();
  }, [pathname]);

  return null;
}
